import React from 'react';
import { MessageCircleIcon, ZapIcon, ShoppingBagIcon } from 'lucide-react';
const UseCases = () => {
  return <section className="py-16 bg-white" data-id="element-2232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2233">
        <div className="text-center mb-12" data-id="element-2234">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2235">Real-World Use Cases</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2236">
            See how our AI shopping advisors help customers find exactly what
            they need across different retail categories
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2237">
          {/* Electronics Use Case */}
          <div className="bg-white rounded-xl shadow-card overflow-hidden border border-gray-200" data-id="element-2238">
            <div className="p-4 bg-primary/5 border-b flex items-center" data-id="element-2239">
              <div className="w-10 h-10 rounded-full bg-white p-2 mr-3 flex items-center justify-center" data-id="element-2240">
                <MessageCircleIcon className="h-6 w-6 text-primary" data-id="element-2241" />
              </div>
              <div data-id="element-2242">
                <h3 className="font-semibold" data-id="element-2243">Electronics Shopping</h3>
                <p className="text-xs text-gray-500" data-id="element-2244">Tech & Gaming</p>
              </div>
            </div>
            <div className="p-4" data-id="element-2245">
              <div className="mb-4 rounded-lg overflow-hidden border border-gray-100" data-id="element-2246">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xqCvzVYoEVd3gfMZHGz9D5/ChatGPT_Image_Sep_9%2C_2025%2C_10_52_02_PM.png" alt="AI helping customer find a gaming laptop" className="w-full h-auto" data-id="element-2247" />
              </div>
              <div className="space-y-3" data-id="element-2248">
                <h4 className="font-medium text-lg" data-id="element-2249">
                  Smart Product Recommendations
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-2250">
                  Our AI understands specific tech needs and budget constraints,
                  guiding customers to the perfect products with personalized
                  recommendations and expert insights.
                </p>
                <div className="flex items-center justify-between text-sm mt-4" data-id="element-2251">
                  <div className="flex items-center text-primary" data-id="element-2252">
                    <ZapIcon className="h-4 w-4 mr-1" data-id="element-2253" />
                    <span data-id="element-2254">+53% conversion rate</span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2255">
                    <ShoppingBagIcon className="h-4 w-4 mr-1" data-id="element-2256" />
                    <span data-id="element-2257">+41% AOV</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Home Goods Use Case */}
          <div className="bg-white rounded-xl shadow-card overflow-hidden border border-gray-200" data-id="element-2258">
            <div className="p-4 bg-primary/5 border-b flex items-center" data-id="element-2259">
              <div className="w-10 h-10 rounded-full bg-white p-2 mr-3 flex items-center justify-center" data-id="element-2260">
                <MessageCircleIcon className="h-6 w-6 text-primary" data-id="element-2261" />
              </div>
              <div data-id="element-2262">
                <h3 className="font-semibold" data-id="element-2263">Home Goods Shopping</h3>
                <p className="text-xs text-gray-500" data-id="element-2264">Bedding & Decor</p>
              </div>
            </div>
            <div className="p-4" data-id="element-2265">
              <div className="mb-4 rounded-lg overflow-hidden border border-gray-100" data-id="element-2266">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rixZfpRqKQQBinSAuYQj1E/ChatGPT_Image_Sep_9%2C_2025%2C_10_43_50_PM.png" alt="AI helping customer find a blue floral duvet" className="w-full h-auto" data-id="element-2267" />
              </div>
              <div className="space-y-3" data-id="element-2268">
                <h4 className="font-medium text-lg" data-id="element-2269">
                  Intuitive Search & Discovery
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-2270">
                  Customers describe what they're looking for in natural
                  language, and our AI instantly shows matching products,
                  suggests complementary items, and helps complete the look.
                </p>
                <div className="flex items-center justify-between text-sm mt-4" data-id="element-2271">
                  <div className="flex items-center text-primary" data-id="element-2272">
                    <ZapIcon className="h-4 w-4 mr-1" data-id="element-2273" />
                    <span data-id="element-2274">+47% conversion rate</span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2275">
                    <ShoppingBagIcon className="h-4 w-4 mr-1" data-id="element-2276" />
                    <span data-id="element-2277">+38% AOV</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Fashion Use Case */}
          <div className="bg-white rounded-xl shadow-card overflow-hidden border border-gray-200" data-id="element-2278">
            <div className="p-4 bg-primary/5 border-b flex items-center" data-id="element-2279">
              <div className="w-10 h-10 rounded-full bg-white p-2 mr-3 flex items-center justify-center" data-id="element-2280">
                <MessageCircleIcon className="h-6 w-6 text-primary" data-id="element-2281" />
              </div>
              <div data-id="element-2282">
                <h3 className="font-semibold" data-id="element-2283">Fashion Shopping</h3>
                <p className="text-xs text-gray-500" data-id="element-2284">Apparel & Clothing</p>
              </div>
            </div>
            <div className="p-4" data-id="element-2285">
              <div className="mb-4 rounded-lg overflow-hidden border border-gray-100" data-id="element-2286">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hbAQYYJxfnyCmb3EjHdDu1/ChatGPT_Image_Sep_9%2C_2025%2C_10_41_47_PM.png" alt="AI helping customer find a lightweight shirt" className="w-full h-auto" data-id="element-2287" />
              </div>
              <div className="space-y-3" data-id="element-2288">
                <h4 className="font-medium text-lg" data-id="element-2289">
                  Personal Styling Assistant
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-2290">
                  Our AI acts as a personal stylist, understanding customer
                  preferences and helping them find the perfect clothing items
                  with helpful suggestions and style advice.
                </p>
                <div className="flex items-center justify-between text-sm mt-4" data-id="element-2291">
                  <div className="flex items-center text-primary" data-id="element-2292">
                    <ZapIcon className="h-4 w-4 mr-1" data-id="element-2293" />
                    <span data-id="element-2294">+49% conversion rate</span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2295">
                    <ShoppingBagIcon className="h-4 w-4 mr-1" data-id="element-2296" />
                    <span data-id="element-2297">+32% AOV</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default UseCases;